import { Popover, Transition } from "@headlessui/react"
import { Link } from "gatsby"
import React, { Fragment } from "react"

function MenuItem({ item, isCurrent }) {
  if (item?.childItems?.nodes.length > 0) {
    return (
      <Popover className="relative">
        {({ open }) => (
          <>
            <Popover.Button
              className={`${open ? "text-gray-900" : "text-gray-500"}
                font-bold text-gray-700 hover:text-gray-900
                group inline-flex items-center `}
            >
              <span>{item.label}</span>
              <i
                className={`bx bx-chevron-down ${
                  open ? "rotate-180" : ""
                } ml-2 text-xl h-5 w-5 group-hover:text-gray-500`}
              />
            </Popover.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute left-1/2 z-10 mt-3 w-screen max-w-xs -translate-x-1/2 transform px-2 sm:px-0">
                <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                  <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                    {item?.childItems?.nodes.map(i => (
                      <a
                        key={i.path}
                        href={i.path}
                        className="-m-3 block rounded-md p-3 transition duration-150 ease-in-out hover:bg-blue-100"
                      >
                        <p className="text-base font-medium text-gray-900">
                          {i.label}
                        </p>
                        {/* <p className="mt-1 text-sm text-gray-500">
                          {item.description}
                        </p> */}
                      </a>
                    ))}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    )
  }

  return (
    <Link
      key={item.label}
      to={item.path}
      className={`font-bold text-gray-700 hover:text-gray-900 menu-roll-over relative ${
        isCurrent ? "menu-roll-over-active" : ""
      }`}
    >
      {item.label}
    </Link>
  )
}

export default MenuItem
